import { c as _c } from "react/compiler-runtime";
import { CheckboxField } from '@shared/ui-components/checkbox-field/checkbox-field';
import { type AdvancedFilterOptions, type FilterSection } from '../../types/advanced-filter-form-data';
import styles from './filter-options.module.scss';
type FilterOptionsProps = {
  filterOptions: AdvancedFilterOptions[FilterSection];
  sectionName: FilterSection;
};
export const FilterOptions = t0 => {
  const $ = _c(7);
  const {
    filterOptions,
    sectionName
  } = t0;
  let t1;
  if ($[0] !== filterOptions || $[1] !== sectionName) {
    let t2;
    if ($[3] !== sectionName) {
      t2 = t3 => {
        const {
          count,
          displayName,
          name
        } = t3;
        return <li className={styles["filter-options-item"]} key={name}><CheckboxField label={`${displayName ?? name} (${count ?? 0})`} name={`${sectionName}.${name}`} /></li>;
      };
      $[3] = sectionName;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = filterOptions.map(t2);
    $[0] = filterOptions;
    $[1] = sectionName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul>{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};